import request from 'superagent';
import {domain} from 'ferries/helpers/common';

export const fetchCurrencyDetails = (currency) =>
  request
    .get(`${domain}/api/v1/ferries/configuration`)
    .set({'Content-Type': 'application/json', 'x-override-header': 'ferryscanner-web'})
    .query([
      `currency=${currency}`,
      'params[]=currencyDetails'
    ].join('&'));

export const fetchLoyaltyConstraints = () =>
  request
    .get(`${domain}/api/v1/ferries/configuration`)
    .set({'Content-Type': 'application/json', 'x-override-header': 'ferryscanner-web'})
    .query({'params[]': 'loyaltyRedeemFactor'})
    .ok(({status}) => [200].includes(status))
    .then(({body}) => body.results.data);

